import { Helmet } from 'react-helmet-async';
import { SITE_URL, CONTACT } from '@/content/site';

const OG_IMAGE = `${SITE_URL}/images/og-image.png`;

export const orgJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'ProfessionalService',
  name: 'KTK Advisors',
  description:
    'Founder-led business advisory helping companies uncover cost-saving opportunities, improve efficiency, and pursue growth.',
  url: `${SITE_URL}/`,
  telephone: CONTACT.phone,
  address: {
    '@type': 'PostalAddress',
    streetAddress: CONTACT.address1,
    addressLocality: 'Hoover',
    addressRegion: 'AL',
    postalCode: '35244',
    addressCountry: 'US',
  },
  founder: {
    '@type': 'Person',
    name: CONTACT.founder,
    jobTitle: 'Founder & CEO',
  },
};

export const faqJsonLd = (items) => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: items.map((i) => ({
    '@type': 'Question',
    name: i.q,
    acceptedAnswer: { '@type': 'Answer', text: i.a },
  })),
});

export default function Seo({ title, description, path = '/', jsonLd }) {
  const url = `${SITE_URL}${path}`;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="KTK Advisors" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={OG_IMAGE} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={OG_IMAGE} />
      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
}
